import { PopupState } from 'material-ui-popup-state/core'
import { createContext } from 'react'

export type PopoverContextStore = {
  popupState: PopupState
  triggerMode?: 'click' | 'hover'
}

const PopoverContext = createContext<PopoverContextStore | undefined>(undefined)

export default PopoverContext
